import { render, staticRenderFns } from "./WaveReport.vue?vue&type=template&id=1df6fc3a&scoped=true"
import script from "./WaveReport.vue?vue&type=script&lang=js"
export * from "./WaveReport.vue?vue&type=script&lang=js"
import style0 from "./WaveReport.vue?vue&type=style&index=0&id=1df6fc3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df6fc3a",
  null
  
)

export default component.exports